export const I80_PROD_HOSTNAME = "order.i80concrete.com";
export const I80_PROD_PORTAL_DATA = {
    parentCompanyId: 1583,
    parentCompanyUUID: "ac5add85-d318-435a-bb36-0551b15f3eb0",
    tabTitle: "I80 CONCRETE",
    customerRole: "I80 Customer",
};
